import { MenuItem } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isSelectableCompanyDropdownOption } from "../../utils/adminCompany";
import {
  getCompanySelectOptions,
  useCompanySelectOptions,
} from "../../services/companySelectOptions";

const renderMenuItems = (
  options,
  currentValue,
  restrictToEnabled = true,
) =>
  options.map((option) => (
    <MenuItem
      key={option.value}
      value={String(option.value)}
      disabled={
        restrictToEnabled &&
        !isSelectableCompanyDropdownOption(option.value, currentValue)
      }
    >
      {option.label}
    </MenuItem>
  ));

/** Sync helper (uses cache / fallback). Prefer <DiscoCompanyMenuItems /> for live API updates. */
export function getDiscoCompanyMenuItems(
  currentValue,
  includePitc = false,
  restrictToEnabled = true,
) {
  return renderMenuItems(
    getCompanySelectOptions({ includePitc }),
    currentValue,
    restrictToEnabled,
  );
}

export function getDiscoCompanyNativeOptions(
  currentValue,
  includePitc = false,
  restrictToEnabled = true,
) {
  return getCompanySelectOptions({ includePitc }).map((option) => (
    <option
      key={option.value}
      value={String(option.value)}
      disabled={
        restrictToEnabled &&
        !isSelectableCompanyDropdownOption(option.value, currentValue)
      }
    >
      {option.label}
    </option>
  ));
}

/** Live company MenuItems — loads getCompanyDetails via shared cache */
const DiscoCompanyMenuItems = ({
  includePitc = false,
  currentValue,
  restrictToEnabled = true,
}) => {
  const token = useSelector((state) => state.auth?.token);
  const options = useCompanySelectOptions({ includePitc, token });
  return renderMenuItems(options, currentValue, restrictToEnabled);
};

DiscoCompanyMenuItems.propTypes = {
  includePitc: PropTypes.bool,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  restrictToEnabled: PropTypes.bool,
};

export default DiscoCompanyMenuItems;
